/* import __COLOCATED_TEMPLATE__ from './saved-messages.hbs'; */
import Component from '@ember/component';
import { closeModal } from 'sh-www/utils/modal-controls';

/**
 * Component required for showing the saved message modals
 */
export default Component.extend({

  /**
   * @inheritDoc
   */
  tagName: '',

  /**
   * @inheritDoc
   */
  actions: {
    /**
     * action called when the user closes the modal
     */
    close() {
      closeModal(this);
    },
  },
});
